import {IArchiveDTO, IArticleListForm} from "@/form/article";

export interface IPublicationDTO {
    pubId: string | null,
    title: string,
    summary: string,
    linkUrl: string,
    disabled: boolean,
    publishDate: Date | null;
    publishDateString?: string;
    coverArhId: IArchiveDTO | null,
    language: string,
}

export interface IPublicationQueryOutputForm {
    totalRows: number;
    firstResult: number;
    totalPages: number;
    startPage: number;
    endPage: number;
    pages: number[];
    nowPage: number;
    obj?: IPublicationDTO[];
}


export interface IEBookDTO {
    ebkId: string | null,
    title: string,
    summary: string,
    linkUrl: string,
    fields: string[],
    fieldCodes: string[],
    year?: number | null,
    publishDate: string;
    publishDateString: string;
    open: boolean;
}

export interface IEBookEditingForm {
    ebkId: string | null,
    title: string,
    summary: string,
    linkUrl: string,
    fields: string[],
    publishDate: Date | null;
    open: boolean;
}

export interface IEBookListDTO {
    ebkId: string,
    title: string,
    summary: string,
    linkUrl: string,
    fields: string[],
    publishDate: string,
    open: boolean,
}

export interface IEBookQueryForm {
    queryText?: string | null,
    fields: string[],
    publishDateSt: Date | null,
    publishDateEn: Date | null,
    rowsPerPage?: number,
    open: string | null
    page: number,
}

export interface IEBookQueryInputForm {
    queryText: string | null;
    year: string | null,
    field: string | null,
    rowsPerPage: number;
    nowPage: number;
}

export interface IEBookQueryOutputForm {
    totalRows: number;
    firstResult: number;
    totalPages: number;
    startPage: number;
    endPage: number;
    pages: number[];
    nowPage: number;
    obj?: IEBookDTO[];
}


export interface SelectOption {
    value: string;
    label: string;
}

export const EbookFieldOptions1: SelectOption[] = [
    { value: "H", label: "科技議題" },
    { value: "B", label: "政策評析" },
    { value: "I", label: "科技政策推動機制" },
    { value: "J", label: "產業發展" },
    { value: "K", label: "創新創業" },
    { value: "G", label: "人才培育" },
    { value: "L", label: "科技與人文之互動" },
    { value: "M", label: "績效評估" },
]

export const EbookFieldOptions: SelectOption[] = [
    { value: "A", label: "專利資訊" },
    { value: "B", label: "政策評析" },
    { value: "C", label: "創新系統" },
    { value: "D", label: "前瞻研究" },
    { value: "E", label: "科學計量" },
    { value: "F", label: "科研投入" },
    { value: "G", label: "人才培育" },
    { value: "H", label: "科技議題" },
    { value: "I", label: "科技政策推動機制" },
    { value: "J", label: "產業發展" },
    { value: "K", label: "創新創業" },
    { value: "L", label: "科技與人文之互動" },
    { value: "M", label: "績效評估" },
    { value: "Z", label: "其他" },
]
